import type { Updater } from '@tanstack/vue-table'
import type { Ref } from 'vue'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { LocationQueryValue } from 'vue-router'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}

/**
 * Sort query parameters alphabetically by key for SEO compliance
 * This ensures internal links always generate canonical URLs with sorted parameters
 * 
 * @param query - Record of query parameters
 * @returns Sorted query parameters object
 */
export function sortQueryParams(query: Record<string, LocationQueryValue | LocationQueryValue[]>): Record<string, LocationQueryValue | LocationQueryValue[]> {
  const sortedQuery: Record<string, LocationQueryValue | LocationQueryValue[]> = {}
  const keys = Object.keys(query).sort()
  
  keys.forEach(key => {
    sortedQuery[key] = query[key]
  })
  
  return sortedQuery
}
